import React from "react";
import { Layout as AntdLayout } from "antd";
import ReduxRedirect from "../../Common/ReduxRedirect";
import LanguageSwitcher from "../../Common/LanguageSwitcher";

import styles from "./index.module.scss";

interface SimpleProps {
  children: React.ReactNode;
}

export default function SimpleLayout({
  children,
}: SimpleProps): React.ReactNode {
  return (
    <>
      <ReduxRedirect />
      <AntdLayout>
        <AntdLayout.Content className={styles.content}>
          {children}
          {/* TODO style where this switcher placed on simple layout screen */}
        </AntdLayout.Content>
      </AntdLayout>
    </>
  );
}
